const UserRole = {
  Admin: {
    id: "a652a97a-6f6c-4508-bfee-64b2298cede2",
    name: "Admin",
    lczKey: ""
  },
  User: {
    id: "93abf3bb-a34d-464e-ab2b-99bdfc44cf64",
    name: "User",
    lczKey: ""
  },
  PublicArticlesEditor: {
    id: "47f26316-00b2-4df5-84cf-b7219dd2f624",
    name: "PublicArticlesEditor",
    lczKey: ""
  },
  PagesEditor: {
    id: "7e464ac2-8a46-43fb-aa60-c4ea3352452f",
    name: "PagesEditor",
    lczKey: ""
  },
  NewsEditor: {
    id: "cedd7f91-07b8-48db-abc5-070213c8f399",
    name: "NewsEditor",
    lczKey: ""
  },
  SurveyEditor: {
    id: "7574c181-a706-4c7c-9689-b77791bc5dec",
    name: "SurveyEditor",
    lczKey: ""
  },
  FormBuilderEditor: {
    id: "57efbb22-bb9a-4c4b-85c3-f4dc9b568717",
    name: "FormBuilderEditor",
    lczKey: ""
  }
};
export {
  UserRole
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
